export default __webpack_public_path__ + "static/media/bg_jp.992a5c41.png";